import React, { useEffect, useRef, useState } from "react";
import { Lock } from "lucide-react";

const LockedFeatureItem = ({
  label,
  icon,
  message,
  className = "",
  labelClassName = "",
  iconClassName = "",
  lockClassName = "",
  bubbleClassName = "",
  stacked = false,
}) => {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  useEffect(() => {
    const handlePointerDown = (event) => {
      if (!rootRef.current?.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handlePointerDown);
    document.addEventListener("touchstart", handlePointerDown);
    return () => {
      document.removeEventListener("mousedown", handlePointerDown);
      document.removeEventListener("touchstart", handlePointerDown);
    };
  }, []);

  return (
    <button
      type="button"
      ref={rootRef}
      onClick={() => setOpen((prev) => !prev)}
      className={`relative ${className}`.trim()}
      aria-label={message || `${label} is locked`}
    >
      {stacked ? (
        <>
          <div className="relative">
            <span className={iconClassName}>{icon}</span>
            <Lock className={lockClassName} />
          </div>
          <span className={labelClassName}>{label}</span>
        </>
      ) : (
        <>
          <span className={iconClassName}>{icon}</span>
          <span className={labelClassName}>{label}</span>
          <Lock className={lockClassName} />
        </>
      )}

      {open ? (
        <div
          className={`absolute left-1/2 top-full z-50 mt-2 -translate-x-1/2 whitespace-normal rounded-xl border border-slate-200 bg-white px-3 py-2 text-xs font-medium text-slate-700 shadow-xl shadow-slate-900/10 ${bubbleClassName}`.trim()}
          role="tooltip"
        >
          {message || "This feature is locked."}
        </div>
      ) : null}
    </button>
  );
};

export default LockedFeatureItem;
